import { Prompt, SnackbarStatus, Typography, useSnackbar } from '@weareopenr/component-library';
import { useState } from 'react';
import { deleteMealtime } from '../../api/deleteMealtime/deleteMealtime';
import { useQueryClient } from '@tanstack/react-query';
import { Status } from 'src/api/constants';

export const DeleteMealtimePrompt = ({
  mealtimeId,
  closePrompt,
  menuId,
}: {
  mealtimeId: string | null;
  closePrompt: () => void;
  menuId: string;
}) => {
  const { showSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const [isLoading, setIsloading] = useState<boolean>(false);
  const handleDeleteMealtime = async () => {
    setIsloading(true);
    try {
      const res = await deleteMealtime(menuId, mealtimeId);
      if (res.status !== Status.NO_CONTENT) {
        throw new Error('Unable to delete mealtime');
      }
      await queryClient.refetchQueries({ queryKey: [menuId, 'mealtimes'] });
      showSnackbar({ status: SnackbarStatus.SUCCESS, message: 'Successfully deleted mealtime' });
      closePrompt();
    } catch (e) {
      showSnackbar({ status: SnackbarStatus.ERROR, message: e.message || 'Unable to delete mealtime' });
    } finally {
      setIsloading(false);
    }
  };
  return (
    <Prompt
      closePrompt={closePrompt}
      open={Boolean(mealtimeId)}
      promptHeading="Are you sure you want to delete mealtime?"
      size="small"
      backButtonText="Back"
      backButton={true}
      buttonHandler={handleDeleteMealtime}
      buttonText="Delete"
      buttonType="button"
      isSubmitting={isLoading}
    >
      <Typography>
        Are you certain you want to remove this mealtime? Deleting it will permanently erase all associated mealtime
        data and cannot be undone.
      </Typography>
    </Prompt>
  );
};
